export default {
      id: "register-claims-usage",
      viewBox: "0 0 24 28",
      url: __webpack_public_path__ + "sprite.svg#register-claims",
      toString: function () {
        return this.url;
      }
    }